module.exports = __webpack_public_path__ + "static/media/de.5f8c7ff6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/de.svg
// module id = 1860
// module chunks = 0